/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */
import { css } from '@emotion/react';
import { N20, N40A, N500 } from '@atlaskit/theme/colors';
export const containerLayout = css({
  display: 'flex',
  flexDirection: 'column'
});
export const previewContainer = css({
  padding: "var(--ds-space-150, 12px)",
  borderTop: `1px solid ${`var(--ds-border, ${N40A})`}`,
  borderBottom: `1px solid ${`var(--ds-border, ${N40A})`}`
});
export const actionsContainer = css({
  display: 'flex',
  flexWrap: 'wrap-reverse',
  justifyContent: 'flex-end',
  gap: "var(--ds-space-100, 8px)",
  paddingTop: "var(--ds-space-150, 12px)"
});
export const actionsButtonGroup = css({
  display: 'flex',
  flexWrap: 'wrap',
  justifyContent: 'flex-end',
  gap: "var(--ds-space-100, 8px)"
});
export const columnLayout = css({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  gap: "var(--ds-space-050, 4px)"
});
export const footerStyles = css({
  display: 'flex',
  flexWrap: 'wrap',
  padding: `${"var(--ds-space-050, 4px)"} ${"var(--ds-space-150, 12px)"}`,
  gap: "var(--ds-space-050, 4px)",
  borderTopLeftRadius: 'unset',
  borderTopRightRadius: 'unset',
  backgroundColor: `var(--ds-background-accent-gray-subtlest, ${N20})`,
  alignItems: 'center',
  justifyContent: 'space-between'
});
export const footerInformationStyles = css({
  display: 'flex',
  flexWrap: 'wrap',
  alignItems: 'center',
  minWidth: 0,
  minHeight: "var(--ds-space-300, 24px)",
  '& > p': {
    color: `var(--ds-text-subtle, ${N500})`,
    fontSize: '11px',
    marginTop: 0
  },
  '& > span': {
    marginTop: "var(--ds-space-050, 4px)",
    marginRight: "var(--ds-space-050, 4px)",
    marginBottom: "var(--ds-space-050, 4px)"
  }
});
export const actionsContainerWrapper = css({
  display: 'flex',
  flexWrap: 'wrap',
  justifyContent: 'flex-end',
  gap: "var(--ds-space-100, 8px)",
  alignItems: 'flex-end',
  flex: 1
});
export const diffToggleWrapper = css({
  display: 'flex',
  flexWrap: 'wrap',
  flex: 1,
  gap: "var(--ds-space-100, 8px)",
  marginTop: "var(--ds-space-150, 12px)"
});